import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import NotificationPreferencesApi from '@infrastructure/notification-preferences-api';
export const getAllNotificationPreferencesAsync = createAsyncThunk('notificationPreferences/getAll', async (_, { rejectWithValue }) => {
    try {
        const response = await NotificationPreferencesApi.getAllNotificationPreferences();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getNotificationPreferencesByModuleAsync = createAsyncThunk('notificationPreferences/getByModule', async (module, { rejectWithValue }) => {
    try {
        const response = await NotificationPreferencesApi.getNotificationPreferencesByModule(module);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getNotificationPreferenceByIdAsync = createAsyncThunk('notificationPreferences/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await NotificationPreferencesApi.getNotificationPreferenceById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createNotificationPreferenceAsync = createAsyncThunk('notificationPreferences/create', async (payload, { rejectWithValue }) => {
    try {
        const response = await NotificationPreferencesApi.createNotificationPreference(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateNotificationPreferenceAsync = createAsyncThunk('notificationPreferences/update', async (payload, { rejectWithValue }) => {
    try {
        const response = await NotificationPreferencesApi.updateNotificationPreference(payload.id, payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteNotificationPreferenceAsync = createAsyncThunk('notificationPreferences/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await NotificationPreferencesApi.deleteNotificationPreference(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getModuleCompaniesAsync = createAsyncThunk('notificationPreferences/getModuleCompanies', async (module, { rejectWithValue }) => {
    try {
        const response = await NotificationPreferencesApi.getModuleCompanies(module);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateModuleCompaniesAsync = createAsyncThunk('notificationPreferences/updateModuleCompanies', async (payload, { rejectWithValue }) => {
    try {
        const response = await NotificationPreferencesApi.updateModuleCompanies(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
